"use strict";

var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteResources = deleteResources;
exports.normalizeResource = normalizeResource;
exports.upsertList = upsertList;
exports.upsertMetadata = upsertMetadata;
exports.upsertRequest = upsertRequest;
exports.upsertResource = upsertResource;
exports.upsertResourceMetadata = upsertResourceMetadata;
exports.upsertResources = upsertResources;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _warning = _interopRequireDefault(require("@flowio/warning"));

var _language = require("./language");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function normalizeResource(resource) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$idAttribute = options.idAttribute,
      idAttribute = _options$idAttribute === void 0 ? 'id' : _options$idAttribute;
  return (0, _language.isObject)(resource) ? resource : (0, _defineProperty2.default)({}, idAttribute, resource);
}

function upsertList() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var previousLists = options.previousLists,
      resources = options.resources,
      listName = options.listName,
      _options$idAttribute2 = options.idAttribute,
      idAttribute = _options$idAttribute2 === void 0 ? 'id' : _options$idAttribute2,
      _options$mergeLists = options.mergeLists,
      mergeLists = _options$mergeLists === void 0 ? true : _options$mergeLists;
  var _previousLists$listNa = previousLists[listName],
      previousList = _previousLists$listNa === void 0 ? [] : _previousLists$listNa;
  var nextList = resources.map(function (resource) {
    return normalizeResource(resource, {
      idAttribute: idAttribute
    });
  }).map(function (resource) {
    return resource[idAttribute];
  });

  if (!previousList.length || !mergeLists) {
    return _objectSpread(_objectSpread({}, previousLists), {}, (0, _defineProperty2.default)({}, listName, nextList));
  }

  return _objectSpread(_objectSpread({}, previousLists), {}, (0, _defineProperty2.default)({}, listName, [].concat((0, _toConsumableArray2.default)(previousList), (0, _toConsumableArray2.default)(nextList))));
}

function upsertRequest() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$idAttribute3 = options.idAttribute,
      idAttribute = _options$idAttribute3 === void 0 ? 'id' : _options$idAttribute3,
      previousRequests = options.previousRequests,
      operationType = options.operationType,
      requestName = options.requestName,
      requestKey = options.requestKey,
      requestStatus = options.requestStatus,
      requestProperties = options.requestProperties,
      resourceType = options.resourceType,
      _options$resources = options.resources,
      resources = _options$resources === void 0 ? [] : _options$resources;

  if ((0, _language.isNil)(requestKey)) {
    return previousRequests;
  }

  var previousRequest = previousRequests[requestKey];

  var nextRequest = _objectSpread(_objectSpread(_objectSpread({}, previousRequest), requestProperties), {}, {
    operationType: operationType,
    requestKey: requestKey,
    requestStatus: requestStatus,
    resourceType: resourceType,
    resources: resources.map(function (resource) {
      return normalizeResource(resource, {
        idAttribute: idAttribute
      });
    }).map(function (resource) {
      return resource[idAttribute];
    })
  });

  if ((0, _language.isNil)(requestName)) {
    nextRequest.requestName = requestName;
  }

  return _objectSpread(_objectSpread({}, previousRequests), {}, (0, _defineProperty2.default)({}, requestKey, nextRequest));
}

function upsertResource(options) {
  var previousResources = options.previousResources,
      resource = options.resource,
      _options$idAttribute4 = options.idAttribute,
      idAttribute = _options$idAttribute4 === void 0 ? 'id' : _options$idAttribute4,
      _options$mergeResourc = options.mergeResources,
      mergeResources = _options$mergeResourc === void 0 ? true : _options$mergeResourc;
  var id = resource[idAttribute]; // If a resource doesn't have an unique identifier,
  // then it cannot be tracked.

  if (!(0, _language.isNumber)(id) && !(0, _language.isString)(id)) {
    (0, _warning.default)(false, 'You attempted to add or update a resource without an unique identifier. ' + 'Every resource must have a unique identifier that is either a number or ' + 'a string. You should check your action creators to make sure that a ' + 'unique identifier is always included in your resources.');
    return previousResources;
  }

  var previousResource = previousResources[id];
  var alreadyExists = !(0, _language.isNil)(previousResource);

  if (!alreadyExists || !mergeResources) {
    return _objectSpread(_objectSpread({}, previousResources), {}, (0, _defineProperty2.default)({}, id, resource));
  }

  return _objectSpread(_objectSpread({}, previousResources), {}, (0, _defineProperty2.default)({}, id, _objectSpread(_objectSpread({}, previousResource), resource)));
}
/**
 * Helper responsible for upserting resources into application state.
 * @param {Object} [options.previousResources] -
 * Resources stored in the application state.
 * @param {Object|Object[]} [options.resources] -
 * Resources to be upserted.
 * @param {String} [options.idAttribute = "id"] -
 * By default, a resource's unique identifier is assumed to be stored under its
 * `id` attribute. If you're communicating with a backend that uses a different
 * unique key, you may set this option to transparently map from that key.
 * @param {String} [options.mergeResources = true] -
 * By default, a resource will be merged when it already exists in the
 * application state. You can set this option to `false` to replace the value
 * in the application state with the incoming resource.
 */


function upsertResources(options) {
  var previousResources = options.previousResources,
      resources = options.resources,
      _options$idAttribute5 = options.idAttribute,
      idAttribute = _options$idAttribute5 === void 0 ? 'id' : _options$idAttribute5,
      _options$mergeResourc2 = options.mergeResources,
      mergeResources = _options$mergeResourc2 === void 0 ? true : _options$mergeResourc2;

  if ((0, _language.isArray)(resources)) {
    return resources.map(function (resource) {
      return normalizeResource(resource, {
        idAttribute: idAttribute
      });
    }).reduce(function (previousValue, resource) {
      return upsertResource({
        previousResources: previousValue,
        resource: resource,
        idAttribute: idAttribute,
        mergeResources: mergeResources
      });
    }, previousResources);
  }

  return (0, _values.default)(resources).reduce(function (previousValue, resource) {
    return upsertResource({
      previousResources: previousValue,
      resource: resource,
      idAttribute: idAttribute,
      mergeResources: mergeResources
    });
  }, previousResources);
}
/**
 * Helper responsible for removing resources stored in the application state.
 * @param {Object} [options.previousResources] -
 * Resources stored in the application state.
 * @param {String[]|Number[]|Object[]} [options.resources] -
 * Resources to be removed.
 * @param {String} [options.idAttribute = "id"] -
 * By default, a resource's unique identifier is assumed to be stored under
 * its `id` attribute. If you're communicating with a backend that uses a
 * different unique key, you may set this option to transparently map from
 * that key.
 */


function deleteResources() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var previousResources = options.previousResources,
      resources = options.resources,
      _options$idAttribute6 = options.idAttribute,
      idAttribute = _options$idAttribute6 === void 0 ? 'id' : _options$idAttribute6;
  var ids = resources.map(function (resource) {
    return normalizeResource(resource, {
      idAttribute: idAttribute
    });
  }).filter(function (resource) {
    var id = resource[idAttribute];
    (0, _warning.default)((0, _language.isNumber)(id) || (0, _language.isString)(id), 'You attempted to delete a resource without an unique identifier. ' + 'Every resource must have a unique identifier that is either a ' + 'number or a string. You should check your action creators to make ' + 'sure that a unique identifier is always included in your resources.');
    return (0, _language.isNumber)(id) || (0, _language.isString)(id);
  }).map(function (resource) {
    return resource[idAttribute];
  });

  var nextResources = _objectSpread({}, previousResources);

  ids.forEach(function (id) {
    delete nextResources[id];
  });
  return nextResources;
}

function upsertMetadata(options) {
  var previousMetadata = options.previousMetadata,
      metadata = options.metadata,
      _options$mergeMetadat = options.mergeMetadata,
      mergeMetadata = _options$mergeMetadat === void 0 ? true : _options$mergeMetadat;

  if ((0, _language.isNil)(metadata)) {
    return previousMetadata;
  }

  return (0, _keys.default)(metadata).reduce(function (previousValue, resourceId) {
    var previousResourceMetadata = previousMetadata[resourceId];
    var nextResourceMetadata = metadata[resourceId];
    var alreadyExists = !(0, _language.isNil)(previousResourceMetadata);

    if (!alreadyExists || !mergeMetadata) {
      return _objectSpread(_objectSpread({}, previousValue), {}, (0, _defineProperty2.default)({}, resourceId, nextResourceMetadata));
    }

    return _objectSpread(_objectSpread({}, previousValue), {}, (0, _defineProperty2.default)({}, resourceId, _objectSpread(_objectSpread({}, previousResourceMetadata), nextResourceMetadata)));
  }, previousMetadata);
}
/**
 * Update one or more individual resources with the same metadata.
 * @param {object} options
 * An object that defines how to update the metadata.
 * @param {array|object} options.resources
 * An array of the resources, or resource identifiers, to update with the
 * specified metadata.
 * @param {object} options.metadata
 * The metadata to set on each of the resources.
 * @param {object} options.previousMetadata
 * The current resource metadata object from the resource slice.
 * Optional when `mergeMetadata` is `false`, required otherwise.
 * @param {object} options.initialResourceMetadata
 * Additional metadata to add to any resource that previously did not
 * have metadata.
 * @param {boolean} [options.mergeMetadata = true]
 * Whether or not to merge a resource's old metadata with the new metadata.
 */


function upsertResourceMetadata(options) {
  var resources = options.resources,
      metadata = options.metadata,
      previousMetadata = options.previousMetadata,
      _options$mergeMetadat2 = options.mergeMetadata,
      mergeMetadata = _options$mergeMetadat2 === void 0 ? true : _options$mergeMetadat2,
      _options$idAttribute7 = options.idAttribute,
      idAttribute = _options$idAttribute7 === void 0 ? 'id' : _options$idAttribute7,
      _options$initialResou = options.initialResourceMetadata,
      initialResourceMetadata = _options$initialResou === void 0 ? {} : _options$initialResou;

  if (!resources) {
    return previousMetadata;
  }

  var resourcesArray = (0, _language.isArray)(resources) ? resources : (0, _values.default)(resources);

  if (!resourcesArray.length) {
    return previousMetadata;
  }

  return resourcesArray.map(function (resource) {
    return normalizeResource(resource, {
      idAttribute: idAttribute
    });
  }).reduce(function (previousValue, resource) {
    var resourceId = resource[idAttribute]; // If we have no unique identifier for this resource, or if its not a
    // number or string, then we bail.

    if ((0, _language.isNil)(resourceId) || !(0, _language.isNumber)(resourceId) && !(0, _language.isString)(resourceId)) {
      return previousValue;
    }

    var currentMetadata = previousMetadata[resourceId];
    var alreadyExists = !(0, _language.isNil)(currentMetadata);

    if (!alreadyExists || !mergeMetadata) {
      return _objectSpread(_objectSpread({}, previousValue), {}, (0, _defineProperty2.default)({}, resourceId, _objectSpread(_objectSpread({}, initialResourceMetadata), metadata)));
    }

    return _objectSpread(_objectSpread({}, previousValue), {}, (0, _defineProperty2.default)({}, resourceId, _objectSpread(_objectSpread(_objectSpread({}, initialResourceMetadata), currentMetadata), metadata)));
  }, previousMetadata);
}